import PriceOverviewItem, { PriceOverviewItemProps } from './PriceOverviewItem';

export type { PriceOverviewItemProps };
export default PriceOverviewItem;
